import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_INGREDIENT_UNITS = `${BASE_URL}/api/ingredient-unit`;

export class IngredientUnitApi {
  static async fetchAll() {
    return (await axiosInstance.get(`${BASE_URL_INGREDIENT_UNITS}`)).data;
  }

  static async create(ingredientUnit) {
    return (await axiosInstance.post(`${BASE_URL_INGREDIENT_UNITS}`, ingredientUnit))
      .data;
  }

  static async deleteById(id) {
    return (await axiosInstance.delete(`${BASE_URL_INGREDIENT_UNITS}/${id}`))
      .data;
  }
}
